import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=bab468a2&scoped=true&"
import script from "./BaseModal.vue?vue&type=script&lang=ts&"
export * from "./BaseModal.vue?vue&type=script&lang=ts&"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=bab468a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab468a2",
  null
  
)

export default component.exports